import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form, Input } from 'antd'
import { useEffect, useState } from 'react'
import { selectSelectedSegment } from '../../../store/SegmentReducer'
import { useAppSelector } from '../../../store/hooks'
import { parseCriteriaPayload } from '../CriteriaConfig'
import SegmentFields from './Fields'

const Update = ({ form }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedSegment())

  // Set once the values are in the form: child effects run before parent ones,
  // so this is what tells the fields to (re)read them.
  const [prefilledId, setPrefilledId] = useState<number | undefined>(undefined)

  // Rebuild the form values from the stored criteria tree: the drawer opens on
  // what the segment currently targets, not on an empty builder.
  useEffect(() => {
    if (item === undefined) return

    form.resetFields()
    form.setFieldsValue({
      id: item.id,
      name: item.title,
      description: item.description,
      icon: item.icon,
      color: item.color,
      ...parseCriteriaPayload(item.criteria),
    })
    setPrefilledId(item.id)
  }, [item?.id, form])

  if (item === undefined) {
    return <></>
  }

  return (
    <SegmentFields form={form} syncKey={prefilledId}>
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>
    </SegmentFields>
  )
}

export default Update
